(function () {
    var resetPasswordContrl = (function () {
        function resetPasswordContrl() {
            this.init.apply(this, arguments);
        }

        resetPasswordContrl.prototype = {
            init: function ($scope, $state, localStorageService, AuthService, $message, $Loading, MKioskService, $stateParams) {
                $scope.vm = this;
                this.$scope = $scope;
                this.$state = $state;
                this.localStorageService = localStorageService;
                this.AuthService = AuthService;
                this.$message = $message;
                this.$Loading = $Loading;
                this.MKioskService = MKioskService;
                this.$stateParams = $stateParams;
                this.resetForm = null;

                this.isPasswordHidden = true;

                this.token = this.$stateParams.token;

                this.currentPasswordStrength = "Medium";

                this.newPassword = "";
                this.confirmNewPassword = "";
                this.tokenValid = false;
                this.isError = false;
                this.errorMessage = "false";

                this.currentLogin = "";

                AuthService.validateResetPasswordToken(this.token).then(
                angular.bind(this, function (x) {
                    this.tokenValid = true;
                    this.currentLogin = x.data.Login;
                }),
                angular.bind(this, function (err) {
                    this.processError(err);
                }));
            },
            processError: function(err) {
                // console.log("processError ", err);
                var codesWeKnow = [
                    "InvalidToken",
                    "InvalidTokenApplication",
                    "InvalidTokenClientId",
                    "TokenIsExpired",
                    "TokenWasAlreadyUsed",
                    "InvalidLogin",
                    "PasswordTooWeak"
                ]
                var errorCode = err.data.code;
        
                this.isError = true;
                if (codesWeKnow.indexOf(errorCode) >= 0) {
                    let key = "msgResetPassword" + errorCode;
                    this.errorMessage = this.$message.get(key);
                } else {
                    this.errorMessage = "";
                    this.$message.error(err);
                }
            },
            initForm: function(resetForm) {
            //   console.log("initForm ", resetForm);
              this.resetForm = resetForm;
            },
            newPasswordChanged: function() {
                this.isPasswordHidden = true;
                this.resetForm.confirmNewPassword.$setValidity("newPasswordIncorrectConfirmed", true);    
                this.checkPasswordStrength();
                // this.resetForm.confirmNewPassword.$setValidity()
                // this.resetForm.$validate();
            },
            confirmNewPasswordChanged: function() {
                this.resetForm.confirmNewPassword.$setValidity("newPasswordIncorrectConfirmed", true);
            },
            submit: function () {
                
                if (this.currentPasswordStrength === 'Weak') { return; }
                if (!this.checkValidReNewPassword(resetForm)) { return; }
                this.$Loading.show();
                this.AuthService.resetPassword(this.currentLogin, this.newPassword, this.token)
                    .then(angular.bind(this, function () {
                        //Fire to parent to update profile
                        this.$message.infor("msgResetPasswordSuccess");

                        this.$state.go("internal.login");
                    }), this.$message.error)
                    .finally(angular.bind(this, function () {
                        this.$Loading.hide();
                    }));
            },
            checkValidReNewPassword: function(resetForm) {
                var newPassword = this.newPassword;
                var confirmNewPassword = this.confirmNewPassword;
        
                if (!newPassword || !confirmNewPassword) return false;
        
                if (newPassword !== confirmNewPassword) {
                    this.resetForm.$setDirty();
                    this.resetForm.confirmNewPassword.$setValidity("newPasswordIncorrectConfirmed", false);
                    
                    return false;
                }
        
                return true;
            },
            checkPasswordStrength: function() {
                this.AuthService.estimatePasswordStrength(this.token, this.currentLogin, this.newPassword).then(angular.bind(this, function (x) {
                    this.currentPasswordStrength = x.data;
                }), this.$message.error)
            },
            generatePassword: function() {
                this.AuthService.generatePassword().then(angular.bind(this, function (x) {
                    this.isPasswordHidden = false;
                    this.newPassword = x.data;
                    this.confirmNewPassword = x.data;

                    this.checkPasswordStrength();
                }), angular.bind(this, function (err) {
                    this.processError(err);
                }));
            },
            toLogonScreen: function () {
                this.$state.go("internal.login");
            }
        };
        resetPasswordContrl.$inject = ['$scope', '$state', 'localStorageService', 'AuthService', '$message', '$Loading', 'MKioskService', '$stateParams'];
        return resetPasswordContrl;
    }());
    angular.module('internal.resetpassword').controller('resetPasswordContrl', resetPasswordContrl)
})();